export var DEFAULT_CURRENCY = "USD";
